import { useQuery } from "react-query";
import tenantApi from "../utils/api/tenant";


export function useTenantFeature(enabled = true) {
    return useQuery("tenantFeatures", () => tenantApi.features.getTenantFeature(), {
        enabled,
    });
}

/**
 * SW2-2187 — HubSpot API tab (Administration). Returns `{ enabled, token }`
 * where `token` is the masked status only (never plaintext). Invalidate
 * "tenantHubspotApi" after every toggle/generate/revoke mutation.
 */
export function useTenantHubspotApi() {
    return useQuery("tenantHubspotApi", () => tenantApi.hubspot.getSettings(), {
        refetchOnWindowFocus: false,
        retry: false,
    });
}
